import type { OrderTodos } from "../ordersApi";
import { assertUnreachable } from "../../misc/utils";

export const todoItemsOrder: (keyof OrderTodos)[] = [
  "createAdvanceInvoice",
  "createFinalInvoice",
  "addBusAndDriverDetails",
  "sendCheckIn",
  "waitForConfirmationsFromProviders",
];

export function labelForTodoItem(key: keyof OrderTodos): string {
  switch (key) {
    case "createAdvanceInvoice":
      return "Faktura zaliczkowa do wystawienia";
    case "createFinalInvoice":
      return "Faktura końcowa do wystawienia";
    case "addBusAndDriverDetails":
      return "Dane kierowcy i busa";
    case "sendCheckIn":
      return "Odprawa do wysłania";
    case "waitForConfirmationsFromProviders":
      return "Oczekiwanie na potwierdzenie od dostawców";
    default:
      assertUnreachable(key, "Unexpected todo item");
  }
}
